import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from '../../../../utils/numbers';

const OffersV4Headline = ({ maxOffer, counterOffer, counterOfferReportChanged }) => {
    if (counterOfferReportChanged) {
        return (
            <div className="offers-v4-headline-block">
                <h1 className="offers-v4-headline">
                    Your loan terms have changed. Please select a new offer.
                </h1>
                <p className="offers-v4-headline__subtext">
                    Your credit profile showed a change from the initial soft credit inquiry that was used to generate your loan offers.
                </p>
            </div>
        );
    }

    if (counterOffer) {
        return (
            <div className="offers-v4-headline-block">
                <h1 className="offers-v4-headline">
                    Your application details have changed, so your original offer is no longer available.
                </h1>
                <p className="offers-v4-headline__subtext">
                    Select a new offer to continue.
                </p>
            </div>
        );
    }

    return (
        <h1 className="offers-v4-headline">
            Great news, you prequalify for up to {formatMoney(maxOffer)}!*
        </h1>
    );
};

OffersV4Headline.propTypes = {
    maxOffer: PropTypes.number.isRequired,
    counterOffer: PropTypes.bool,
    counterOfferReportChanged: PropTypes.bool,
};

OffersV4Headline.defaultProps = {
    counterOffer: false,
    counterOfferReportChanged: false,
};

export default OffersV4Headline;
